import { defineMessages, useT } from "../i18n/index.ts";
import type { ParamsError } from "../params.ts";

const messages = defineMessages(
  {
    missing: "Aucun livre à ouvrir.",
    invalid: "Lien de lecture invalide.",
    untrusted: "Ce lien de lecture ne provient pas d'une source autorisée.",
  },
  {
    missing: "There is no book to open.",
    invalid: "This reading link is invalid.",
    untrusted: "This reading link doesn't come from a trusted source.",
  },
);

/** Lien direct vers un manifest refusé. */
export function OpenError({ error }: { error: ParamsError }) {
  const t = useT(messages);
  return <p class="reader-message">{t(error)}</p>;
}
